import type { CoworkWorkspaceAgent } from "@/cowork/api"
import { coworkAgentRegistry } from "./report-template-registry.generated"

export function activeRuntimeAgentOptions(
  runtimeOptions: string[],
  agents: CoworkWorkspaceAgent[],
  context: { company_id: string; project_id: string },
) {
  const visible = agents.filter(
    (agent) =>
      agent.status === "active" &&
      agent.assignments.some(
        (assignment) =>
          assignment.scope_type === "workspace" ||
          (assignment.scope_type === "entity" && assignment.scope_id === context.company_id) ||
          (assignment.scope_type === "project" && assignment.scope_id === context.project_id),
      ),
  )
  return runtimeOptions.filter((name) => visible.some((agent) => workspaceAgentMatchesRuntime(agent, name)))
}

export function runtimeAgentOption(
  runtimeOptions: string[],
  agents: CoworkWorkspaceAgent[],
  agentID: string | undefined,
) {
  if (!agentID) return
  const agent = agents.find((item) => item.id === agentID || item.template_id === agentID)
  if (agent) return runtimeOptions.find((name) => workspaceAgentMatchesRuntime(agent, name))
  return runtimeOptions.find((name) => templateMatchesRuntime(agentID, name))
}

export function runtimeAgentOptionFromMetadata(
  runtimeOptions: string[],
  agents: CoworkWorkspaceAgent[],
  metadata: Record<string, unknown>,
) {
  const agent = metadata.agent
  if (!agent || typeof agent !== "object") return
  const value = agent as { id?: unknown; template_id?: unknown; runtime_agent_name?: unknown }
  if (typeof value.runtime_agent_name === "string") return runtimeOptions.find((name) => name === value.runtime_agent_name)
  const agentID = typeof value.id === "string" ? value.id : undefined
  const templateID = typeof value.template_id === "string" ? value.template_id : undefined
  return runtimeAgentOption(runtimeOptions, agents, agentID) ?? runtimeAgentOption(runtimeOptions, agents, templateID)
}

function workspaceAgentMatchesRuntime(agent: CoworkWorkspaceAgent, runtimeName: string) {
  if (typeof agent.metadata.runtime_agent_name === "string") return agent.metadata.runtime_agent_name === runtimeName
  return !!agent.template_id && templateMatchesRuntime(agent.template_id, runtimeName)
}

function templateMatchesRuntime(templateID: string, runtimeName: string) {
  return Object.entries(coworkAgentRegistry).some(([id, value]) => id === templateID && value.runtime_agent === runtimeName)
}
